const LineProgressBar = ({ index = 0, totalPages = 0 }: IPropsLineProgressBar) => {
    let width = ((100 / totalPages) * index);
    let styleCss = {
        background: `linear-gradient(90deg,#008964 0%,#008964 ${width}%,#E5E4E4 ${width}%,#E5E4E4 100%)`
    }

    return (
        <>
            {index >= 0 && <>
                <div className="lbl-lineprogressbar-reclamos-inspeccion-ni">
                    <label>Paso {index > totalPages ? totalPages : index} de {totalPages}</label>
                </div>
                <div className="status-bar-vida-cr mt-5" style={styleCss} />
            </>}
        </>
    )
}

export { LineProgressBar }